import { Component, OnInit } from '@angular/core';
import {Validators, FormControl, FormGroup} from "@angular/forms";
import {AuthService} from "../../core/auth.service";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {Subject} from "rxjs";
import "rxjs/add/operator/takeUntil";
import { StateService } from 'app/core/state.service';


@Component({
    selector: 'authenticate',
    templateUrl: './authenticate.component.html',
    styleUrls: ['./authenticate.component.sass']
})
export class AuthenticateComponent implements OnInit {

    public accountId;
    public sendingEmailLoading:boolean = false;
    public controls = new FormGroup({
        firstName : new FormControl('', [ Validators.required ]),
        lastName : new FormControl('', [ Validators.required ]),
        agree : new FormControl('', [ Validators.required ]),
        password : new FormControl('', [ Validators.required, Validators.minLength(6) ]),
        conf_password : new FormControl('', [ Validators.required, Validators.minLength(6) ]),
        email : new FormControl('', [
            Validators.required,
            Validators.email,
        ])
    });
    public login_controls = new FormGroup({
        password : new FormControl('', [ Validators.required, Validators.minLength(6) ]),
        email : new FormControl('', [
            Validators.required,
            Validators.email,
        ])
    });

    private $destroy:Subject<boolean> = new Subject();

    constructor( private auth: AuthService, private state: StateService, private route: ActivatedRoute, private router:Router) {
        // auth.signOut();
        this.route.data.takeUntil(this.$destroy).subscribe(data=>{
            this.auth.is_create_user = data['is_create_user'];
        })
        this.auth.user.takeUntil(this.$destroy).subscribe(u => {
            if (u) {
                if(u.currentAccount){ // this doesn't work anymore because it isn't set correctly
                    this.state.setAccount('currentId',u.currentAccount,u.uid);
                    this.router.navigate(['/checkit-dashboard']);
                }
            }
        })
    }
    signin(){
        if(this.login_controls.status != 'VALID') return;
        this.auth.signing_in = true;
        this.auth.error = null;
        this.auth.signInWithEmailAndPassword(this.login_controls.value.email,this.login_controls.value.password)
    }
    createUser(){
        if(this.controls.status != 'VALID' || this.auth.creating_user) return;
        this.auth.creating_user = true;
        let user_obj = {};
        user_obj['firstName'] = this.controls.value.firstName;
        user_obj['lastName'] = this.controls.value.lastName;
        user_obj['displayName'] = this.controls.value.firstName + ' ' + this.controls.value.lastName;
        console.log('user_obj',user_obj,this.controls.value)
        let user = this.auth.createUser(this.controls.value.email,this.controls.value.password, user_obj);
        console.log("createUser - user = " ,user);
        /*user.then(user=>{
            if(user){
                if(!this.accountId){ // if there is no accountId then create an account and assign to user
                    this.auth.createAccount(user);
                }else{ // just assign account id to user, and user to account
                    this.auth.setUserAccountId(user,this.accountId);
                }
            }
        })*/
    }
    forgotPassword(){
        this.auth.password_email_reset_loading = true;
        this.auth.sendPasswordResetEmail(this.login_controls.value.email);
    }

    ngOnInit() {
    }

    dataCallback(response) {
        console.log("dataCallback", response)
        window.location.href = "/checkRecaptcha?response=" + encodeURIComponent(response)
    }
    dataExpiredCallback() {
        console.log("dataExpiredCallback")
    }

    ngOnDestroy(){
        this.$destroy.next();this.$destroy.complete();
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/authenticate/authenticate.component.ts